import {createReducer} from '@reduxjs/toolkit'
import {getConnectedGroup, getGroupActivity} from '../actions/groups'
import {GroupsState} from '../types/state'

const defaultState: GroupsState = {
  group: undefined,
  updates: undefined,
}

export const groups = createReducer(defaultState, builder => {
  builder
    .addCase(getConnectedGroup.fulfilled, (state, action) => {
      state.group = action.payload?.group
    })
    .addCase(getGroupActivity.fulfilled, (state, action) => {
      state.updates = action.payload.totalPosts
    })
})
